import React, { useEffect, useState } from "react";
import './fulfilment.scss'
import FilterImg from '../../assets/images/filter-vertical-fulfilment.svg'
import { Button, Row, Col, Drawer, Space, Collapse, Select, Form, AutoComplete, Tag, DatePicker } from "antd";
import {  DownOutlined, UpOutlined, SearchOutlined, CloseOutlined } from "@ant-design/icons";
import InquiriesAllocatedCard from "./components/inquiries-allocated-card";
import CompletionBookingChart from "./components/completion-booking-chart";
import { useStore } from "../../store/store";
import { FulfilmentDashboardMetric,GetFulfillmentFiltersData } from "../../service/fulfilment/fulfilmentService";
import * as masterDataService from "../../service/masterDataService";
import * as settingsService from "../../service/settingsService";
import { checkIsGCCCountry } from "../../util/constantUtility";
import CalendarImg from "../../assets/images/calendar-icon.svg";

import dayjs from "dayjs";

import { MultiSelectFilterSearch } from "../loads/component/multi-select-filter-search/multi-select-filter-search";

import moment from "moment";

import { t } from "i18next";
import { values } from "lodash";
const { Panel } = Collapse;



const Fulfilment = () => {
    const { RangePicker } = DatePicker;

    const [fulfilmentForm] = Form.useForm();
    const [activeTab, setActiveTab] = useState('pending')
    const { user, saveUser } = useStore();
    const [fulfilmentDashboardData, setFulfilmentDashboardData] = useState({})
    const [filterLoader , setFilterLoader]=useState(false);
      const [filterModal, setFilterModal] = useState(false);
    
    const [fulfilmentFilter, setFulfilmentFilter] = useState(() => {
        const today = new Date();
        // const last7Days = new Date(today);
        // last7Days.setDate(today.getDate() - 7);  
      
        // const fromDate = last7Days.toISOString().split('T')[0]; 
        // const toDate = today.toISOString().split('T')[0];  
        const firstDayOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
        const lastDayOfMonth = new Date(Date.UTC(today.getFullYear(), today.getMonth() + 1, 0));
        
        const fromDate = firstDayOfMonth.toISOString().split('T')[0];
        const toDate = lastDayOfMonth.toISOString().split('T')[0];
      
        return {
          moveDate: {
            fromDate: fromDate,
            toDate: toDate
          }
        };
      });
        // const [truckTypeOptions, setTruckTypeOptions] = useState([]);
        //     const [subTruckTypeOptions, setSubTruckTypeOptions] = useState([]);
        // const [truckTypeWaiter, setTruckTypeWaiter] = useState(false);
        //     const [subTruckTypeWaiter, setSubTruckTypeWaiter] = useState(false);
        //       const [serviceTypesList, setServiceTypesList] = useState();
          const [customerListWaiter, setCustomerListWaiter] = useState(false);
            const [interSourcerTypeOptions, setInterSourcerTypeOptions] = useState([]);
              const [selectedCustomerList, setSelectedCustomerList] = useState([]);
              const [selectedTruckType, setSelectedTruckType] = useState();
              const [filterdMasterData,setfilterdMasterData] =useState({
                truckTypes:[],
                shippers:[],
                serviceTypes:[]
              })
              const [selectedData,setselectedData] =useState({
                shippers:[],
                truckTypes:[],
                serviceTypes:[]
              })
            
const [selectedFilterCount,setSelectedFilterCount]= useState(0)    
const [currentDate,setcurrentDate]= useState({
  fromDate:'',
  toDate:''
})    

          
const getCurrentDate = (current) => {
  console.log(current,'cur')
  const extractDate = (dateStr) => dateStr?.slice(0, 10); // Gets 'YYYY-MM-DD'

  const formattedFromDate = extractDate(current?.fromDate);
  const formattedToDate = extractDate(current?.toDate);

  setFulfilmentFilter((prev) => ({
    ...prev,
    moveDate: {
      fromDate: formattedFromDate,
      toDate: formattedToDate,
    },
  }));

  setcurrentDate((prev) => ({
    ...prev,
    fromDate: formattedFromDate,
    toDate: formattedToDate,
  }));
  // setFulfilmentFilter(null)

  // if (formattedFromDate && formattedToDate) {
  //   const today = new Date();
  //   const last7Days = new Date();
  //   last7Days.setDate(today.getDate() - 7);

  //   const defaultFrom = last7Days.toISOString().split("T")[0];
  //   const defaultTo = today.toISOString().split("T")[0];

  //   setFulfilmentFilter({
  //     moveDate: {
  //       fromDate: defaultFrom,
  //       toDate: defaultTo,
  //     },
  //   });
  // }
  
};




      useEffect(()=>{
        fetchData();
          getFilterMasterDate()
        
      },[fulfilmentFilter,currentDate])

       const getFilterMasterDate = async()=>{
const response=await GetFulfillmentFiltersData();
const data=response?.data?.data
// console.log(response.data.data)
if(data){
  console.log(data?.truckTypes,'truck')
  if (data) {
    setfilterdMasterData({
      truckTypes: data.truckTypes || [],
      shippers: data.shippers || [],
      serviceTypes: data.serviceTypes || []
    });
}
       }
      }

        const fetchData = async () => {
            setFilterLoader(true)
            if (user?.userId) {
                try {
                    const response = await FulfilmentDashboardMetric({
                        "fromDate":fulfilmentFilter?.moveDate?.fromDate + "T00:00:00",
                        "toDate": fulfilmentFilter?.moveDate?.toDate + "T23:59:59",
                        "userId": user?.userId 
                    });


                    setFulfilmentDashboardData(response?.data?.data)
                    setFilterLoader(false)
                   
                } catch (error) {
                    setFilterLoader(false)
                    console.error("Error fetching FulfilmentDashboardMetric:", error);
                }
            }
        };

       const handleSelectedData = (key, value) =>{
        console.log(key,value)
        setselectedData((pre)=>({
          ...pre,
          [key]:value

        }))

       }

const handleApplyFilterFullfilment = async()=>{
    setFilterLoader(true);

    console.log(fulfilmentForm.getFieldValue("selectedCustomer"))
    if (user?.userId) {
        try {
            const response = await FulfilmentDashboardMetric({
                "fromDate":fulfilmentFilter?.moveDate?.fromDate + "T00:00:00",
                "toDate":fulfilmentFilter?.moveDate?.toDate + "T23:59:59",
                "shipperIds": fulfilmentForm.getFieldValue("selectedCustomer"),
                "serviceTypes": fulfilmentForm.getFieldValue("serviceTypes")?.length>0 ?  fulfilmentForm.getFieldValue('serviceTypes') : [],
                "truckTypes":fulfilmentForm.getFieldValue("truckType") ? fulfilmentForm.getFieldValue("truckType") : [],
                //   "subTruckTypes": fulfilmentForm.getFieldValue("subTruckType")?.length>0 ? 
                // fulfilmentForm.getFieldValue('subTruckType') : []
                  
            });


            setFulfilmentDashboardData(response?.data?.data);
            setFilterLoader(false)
            setFilterModal(false)
            updateSelectedFilterCount()

           
        } catch (error) {
            setFilterLoader(false)
            console.error("Error fetching FulfilmentDashboardMetric:", error);
        }
    }
}


const updateSelectedFilterCount = () => {
  const filters = [
    selectedData.shippers,
    selectedData.truckTypes,
    selectedData.serviceTypes,
  ];

  const count = filters.filter(
    (item) => Array.isArray(item) && item.length > 0
  ).length;

  setSelectedFilterCount(count);
};
    




    //  const getTruckType = () => {
    //     setTruckTypeOptions([]);
    //     setTruckTypeWaiter(true);
    //     masterDataService
    //       .getTruckType("truckType", "FTL")
    //       .then((response) => {
    
    //         setTruckTypeWaiter(false);
    //         let truckTypes = [];
    //         if (checkIsGCCCountry(user.operatingCountry)) {
    //           let gccTruckTypes = response.data.filter(z => z.region == "GCC");
    //           let nonGccTruckTypes = response.data.filter(z => z.region != "GCC");
    //           truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
    //         }
    //         else if (user.operatingCountry == "Turkey") {
    //           let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == "tr");
    //           let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != "tr");
    //           truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
    //         } else if (user.operatingCountry == "Kazakhstan") {
    //           let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == "kaz");
    //           let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != "kaz");
    //           truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
    //         } else {
    //           if (response.data.some(z => z.region?.toLowerCase() == user.operatingCountry?.toLowerCase())) {
    //             let gccTruckTypes = response.data.filter(z => z.region?.toLowerCase() == user.operatingCountry?.toLowerCase());
    //             let nonGccTruckTypes = response.data.filter(z => z.region?.toLowerCase() != user.operatingCountry?.toLowerCase());
    //             truckTypes = [...gccTruckTypes, ...nonGccTruckTypes];
    //           }
    //         }
    
    
    
    
    //         setTruckTypeOptions(
    //           truckTypes.length > 0
    //             ? truckTypes
    //             : []
    //         );
    //       })
    //       .catch((error) => {
    //         setTruckTypeWaiter(false);
    //       });
    //   };

        // const getInternalSourcerPreferences = async (searchValue) => {  
        //   const payload=  {
        //    searchShipperName: searchValue
        //   }
      
        //   try {
        //     setCustomerListWaiter(true);
        //     const res = await settingsService.getShipperListForInternalSourcer(payload );
        //      setCustomerListWaiter(false);
        //     if (res.status === 200) {
        //       let shipperList = res?.data?.data?.map((ele) => {
        //         return {
        //           label: ele.shipperName,
        //           value: ele.shipperId,
        //         };
        //       });
        //       setInterSourcerTypeOptions(shipperList);
        //     }
        //   } catch (err) {
        //      setCustomerListWaiter(false);
        //   }
        // };


        // const onSelectCustomer = (option)=>{
        //     let options = fulfilmentForm.getFieldValue("selectedCustomer");
        //     let newObj = {
        //       shipperId: option.value,
        //       shipperName: option.label,
        //     }
        //     // (newObj?.shipperId)

        //     if (!options || options.length == 0) {
        //       options = [];
        //       options.push(option.label);
        //       setSelectedCustomerList([{...newObj}]);
        //     } else {
        //       if (options?.findIndex((z) => z == option.value) == -1) {
        //         options.push(option.label);
        //         setSelectedCustomerList((prev) => [...prev, newObj]);
        //       }
        //     }
        //     fulfilmentForm.setFieldValue("selectedCustomer", options);
        //     fulfilmentForm.setFieldValue("customer", "");
        //     setUpdateTrigger((prev) => prev + 1);
        //   }


          // const generateCustomerTag = (options, type) => {
            
          //   return options?.map((z) => {
          //     console.log(z,'z')
          //     return (
          //       <>
          //         <Tag
          //           color="rgb(255, 93, 0)"
          //           key={z}
          //           closable
          //           style={{
          //             userSelect: "none",
          //             marginBottom: "8px",
          //             padding: "5px",
          //           }}
          //           //  onClose={() => handleCustomerClose(z, type,z.shipperId)}
          //           onClose={() => handleCustomerClose(z, type)}

          //         >
          //           {" "}
          //           {z}
          //         </Tag>
          //       </>
          //     );
          //   });
          // };

          // const handleCustomerClose = (option, type) => {
          //   let options = fulfilmentForm.getFieldValue(type);


          //   fulfilmentForm.setFieldValue(
          //     type,
          //     options.filter((z) => z != option)
          //   );
          //   setUpdateTrigger((prev) => prev + 1);
          //   let localCollection = [...selectedCustomerList];
          //   localCollection = localCollection.filter((ele) => ele.shipperName !== option);
          //   console.log(localCollection,'local')
          //   setSelectedCustomerList(localCollection);
            
          // };

            // const getSubTruckType = (truckType) => {

            //     // const truckType = fulfilmentForm.getFieldValue("truckType")
            //       setSubTruckTypeWaiter(true);
            //       masterDataService
            //           .getSubTruckType(truckType)
            //           .then((response) => {
            //               if (response.status === 200) {
            //                   setSubTruckTypeWaiter(false);
            //                   const result = response.data?.map((item, index) => ({
            //                       value: item.subTruckType,
            //                       label: item.subTruckType,
            //                       key: index,
            //                   }));
            //                   setSubTruckTypeOptions(result);
            //                   console.log(result,'res')
            //               }
            //           })
            //           .catch((error) => {
            //               setSubTruckTypeWaiter(false);
            //           });
            //   };


              //  const getServiceTypes = async () => {
              //     try {
              //       const res = await masterDataService.getServicesTypeMaster();
              //       if (res.status === 200) {
              //         let filterData=res.data.filter((e)=>e.serviceTypeCode === 'CB' || e.serviceTypeCode === 'DOM')
              //         setServiceTypesList(filterData);
              //       }
              //     } catch (err) {
              //     }
              //   };

                const handleClearAdditionalFilter = () =>{
                  fulfilmentForm.resetFields();
                  setSelectedCustomerList([]); 
                  setSelectedTruckType(null);
                  fetchData();
                  setFilterModal(false);
                  setSelectedFilterCount(0)
                  setselectedData({
                    shippers: [],
                    truckTypes: [],
                    serviceTypes: [],
                  });
                  


                }


                // const handleDateChange = (dates) => {
                //     if (dates && dates.length === 2) {
                //         const fromDate = dates[0].format("YYYY-MM-DD");
                //         const toDate = dates[1].format("YYYY-MM-DD");
            
                //         // Update fulfilmentFilter with selected date range
                //         setFulfilmentFilter({
                //             ...fulfilmentFilter,
                //             moveDate: {
                //                 fromDate: fromDate,
                //                 toDate: toDate
                //             }
                //         });
                //     }
                // };


          
    return (
        <>
            <div className="fulfilment-wrapper">
                <div className="inquiries-card">
                    <Row className="btn-row">
                        <div className="tab-status-div">
                        <Button onClick={() => setActiveTab('pending')} className={activeTab == 'pending' ? "active-btn" : "inactive-btn"}>{t("HOME_PENDING")}</Button>
                            <Button onClick={() => setActiveTab('completed')} className={activeTab == 'completed' ? "active-btn" : "inactive-btn"}>{t("HOME_COMPLETED")}</Button>
                        </div>
                        <div>
                           <Button className={ selectedFilterCount > 0 ? "filter-btn-count":"filter-btn"} onClick={() => setFilterModal(true)}><img style={{color: selectedFilterCount > 0  ? "#E95D05" : null}} src={FilterImg} alt="filter" />{t("HOME_FILTER")}
                           {
                    selectedFilterCount > 0 &&  
                    <span className="circle">
                    {selectedFilterCount+1}
                    </span>
                    } 
                           </Button>
                        </div>
                    </Row>


                    {fulfilmentDashboardData && <InquiriesAllocatedCard getCurrentDateFn= {getCurrentDate}  activeTab={activeTab} data={fulfilmentDashboardData} fulfilmentFilter={fulfilmentFilter} setFulfilmentFilter={setFulfilmentFilter} filterLoader={filterLoader} />}

                </div>
                <div className="completion-booking-wrapper">
                    {fulfilmentDashboardData && <CompletionBookingChart data={fulfilmentDashboardData} />}
                </div>
            </div>


             {filterModal &&
             
                    <Drawer
                      drawer
                      placement="right"
                      visible={filterModal}
                      onClose={() => setFilterModal(false)}
                      width={600} className="orders-reverse-modal"
                      closable={false}
                      title={
                        <>
                          <div className="orders-title-filter-modal">
                            <span>{t("MORE_FILTERS")}</span>
                            <Space direction="horizontal">
                              <Button
                                type="link"
                                onClick={handleClearAdditionalFilter}
                                className="orders-clear-filters"
                              >
                                {t("CLEAR_FILTERS")}
                              </Button>
                            </Space>
                            <Button
                            icon={<CloseOutlined />}
                            type="text"
                            onClick={() => setFilterModal(false)}
                            style={{ fontSize: "16px" }}
                          />
                          </div>
                        </>
                      }
                    >
                     <Form form={fulfilmentForm}>
                     <div className="orders-filter-holder">
                        <Collapse
                          className="orders-load-collapse-filter"
                          expandIcon={({ isActive }) =>
                            isActive ? <UpOutlined /> : <DownOutlined />
                          }
                          expandIconPosition={"right"}
                          accordion={false}
                        >

                        </Collapse>
                        <Collapse
                className="orders-load-collapse-filter"
                expandIcon={({ isActive }) =>
                isActive ? <UpOutlined /> : <DownOutlined />
                }
                expandIconPosition={"right"}
                accordion={false}
                >
                <Panel
                key="Customer"
                header={
                  <>
                    {t("USER_PREF_CUSTOMER_HEADER")}
                    {selectedData.shippers.length > 0  && (
                      <span className="circle">
                        {selectedData.shippers.length}
                      </span>
                    )}
                  </>
                }
                >
                <Row>
                  <Col span={24}>
                    <Form.Item name="selectedCustomer">
                      <Select
                        mode="multiple"
                        loading={customerListWaiter}
                        className="select-filter"
                        options={
                          filterdMasterData?.shippers?.map((item) => ({
                            label: item.shipperName,
                            value: item.shipperId, // or item.shipperId if that's the key you want
                          })) || []
                        }
                        showSearch
                        placeholder={t("USER_PREF_CUSTOMER_PH")}
                        filterOption={(input, option) =>
                          option?.label?.toLowerCase().includes(input?.toLowerCase())
                        }
                        onChange={(value) => {
                          fulfilmentForm.setFieldValue("selectedCustomer", value);
                          handleSelectedData("shippers",value)

                        }}
                        value={fulfilmentForm.getFieldValue("selectedCustomer")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                </Panel>
                </Collapse>



                        <Collapse
                          className="orders-load-collapse-filter"
                          // activeKey={activeKey} onChange={handlePanelChange}
                          expandIcon={({ isActive }) =>
                            isActive ? <UpOutlined /> : <DownOutlined />
                          }
                          expandIconPosition={"right"}
                          accordion={false}
                        >
                          <Panel key={"truckTypeFilter"} header={<>
                           {t("TRUCK_TYPE")}
                           {selectedData?.truckTypes.length > 0 && (
                            <span className="circle">
                              {selectedData?.truckTypes?.length}
                            </span>
                          )}
                                                </>
                            }>
                             <Form.Item name="truckType">
                              <Select
                                mode="multiple"
                                showSearch
                                className="select"
                                placeholder={t("USER_PREF_TRUCK_TYPE_PH")}
                                options={
                                  filterdMasterData.truckTypes?.map((item) => ({
                                    label: item,
                                    value: item,
                                  })) || []
                                }                               
                                filterOption={(input, option) =>{
                                  console.log(option,'op')
                                  option?.label?.toLowerCase().includes(input.toLowerCase())}
                                }
                                style={{
                                  width: "100%",
                                }}
                                onChange={(value)=>handleSelectedData("truckTypes",value)}
                                // onChange={(value ,option) => {
                                //     console.log(value,'val')
                                    
                                   
                                    

                                //   }
                                // }
                                >

                              </Select>
                              </Form.Item>
                        
                          </Panel>
                        </Collapse>
            
                        {/* <Collapse
                          className="orders-load-collapse-filter"
                          expandIcon={({ isActive }) =>
                            isActive ? <UpOutlined /> : <DownOutlined />
                          }
                          expandIconPosition={"right"}
                          accordion={false}
                        >
                          <Panel key={"subTruckTypeFilter"} header={t("SUB_TRUCK_TYPE")}>
                            <Form.Item name="subTruckType">
                        
                              <Select                               
                                showSearch
                                className="select"
                                placeholder={t("USER_PREF_TRUCK_TYPE_PH")}
                                options={subTruckTypeOptions}
                                // fieldNames={{ label: "name", value: "name" }}
                                filterOption={(input, option) =>
                                  option?.label?.toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                style={{
                                  width: "100%",
                                }}
                                mode="multiple"
                                maxTagCount="responsive" 
                                >

                              </Select>
                                </Form.Item>
                        
                          </Panel>
                        </Collapse>
             */}
            
                        <Collapse
                          className="orders-load-collapse-filter"
                          expandIcon={({ isActive }) =>
                            isActive ? <UpOutlined /> : <DownOutlined />
                          }
                          expandIconPosition={"right"}
                          accordion={false}
                        >
                         <Panel key={"serviceTypeFilter"} header={<>
                          {t("SIGNUP_BASIC_INFO_SERVICE_TYPE")}
                          {selectedData?.serviceTypes.length > 0 && (
                            <span className="circle">
                              {selectedData?.serviceTypes.length}
                            </span>
                          )}
                          </>}>
                        
                        <Form.Item name="serviceTypes">
                            <Select
                                        className="floating-select"
                                        placeholder={t("SIGNUP_BASIC_INFO_SERVICE_TYPE_PH")}
                                        // options={serviceTypesList}
                                        options={filterdMasterData?.serviceTypes.map((item)=>({
                                          label:item,
                                          value:item
                                        }))}
                                        mode="multiple"
                                        onChange={(value) => {
                                          fulfilmentForm.setFieldValue("serviceTypes", value);
                                          handleSelectedData("serviceTypes", value)
                                        }}
                                        style={{ width: '520px' }}
                                      />

                        </Form.Item>

                        </Panel>

                        </Collapse>



{/* 
                        <Collapse
                          className="orders-load-collapse-filter"
                          // activeKey={activeKey} onChange={handlePanelChange}
                          expandIcon={({ isActive }) =>
                            isActive ? <UpOutlined /> : <DownOutlined />
                          }
                          expandIconPosition={"right"}
                          accordion={false}
                        >
                        <Panel key={"moveDateFilter"} header={t("ORDER_MOVE_DATE")}>
                        <Form.Item name="moveDate">
                             <RangePicker
                             
                            className="orders-custom-input"
                            defaultValue={[
                                dayjs(fulfilmentFilter.moveDate.fromDate),
                                dayjs(fulfilmentFilter.moveDate.toDate)
                            ]}
                            value={[
                                fulfilmentFilter.moveDate.fromDate
                                    ? dayjs(fulfilmentFilter.moveDate.fromDate)
                                    : null,
                                fulfilmentFilter.moveDate.toDate
                                    ? dayjs(fulfilmentFilter.moveDate.toDate)
                                    : null,
                            ]}
                         onChange={handleDateChange}
                            placeholder={[t("LOADS_FILTER_START_DATE"), t("LOADS_FILTER_END_DATE")]}
                            suffixIcon={  <img style={{width:"15px"}} src={CalendarImg} />}

                        />
                       

                        </Form.Item>

                        </Panel>

                        </Collapse> */}
                        <Space
                          className="orders-space-horizontal-space"
                          direction="horizontal"
                          size="middle"
                        >
                          <Button
                            type="secondary"
                            className="orders-cancel-btn"
                            onClick={() => {
                              setFilterModal(false);
                            }}
                          >
                            {t("COMMON_CANCEL_BTN")}
                          </Button>
                          <Button
                            type="secondary"
                            className="orders-submit-btn"
                            onClick={handleApplyFilterFullfilment}
                          
                          >
                            {t("COMMON_APPLY_BTN")}
                          </Button>
                        </Space>
                      </div>
                     </Form>
                    </Drawer>
                  }
        </>
    );
}
export default Fulfilment;
